import axios from 'axios';

import { userConstants } from 'authentication/_constants';
import { alertActions } from 'authentication/_actions';
import { store } from 'authentication/_helpers/store';

import {
    getJsonAuthConfig,
    getStoredToken,
    isInternalApiRequest,
    logoutIfUnauthorized
} from './session';

const apiClient = axios.create();

function getForbiddenMessage(error) {
    const responseData = error && error.response ? error.response.data : null;

    if (typeof responseData === 'string' && responseData.length > 0) {
        return responseData;
    }

    if (responseData && typeof responseData.message === 'string' && responseData.message.length > 0) {
        return responseData.message;
    }

    if (responseData && typeof responseData.error === 'string' && responseData.error.length > 0) {
        return responseData.error;
    }

    return 'You do not have permission to perform this action.';
}

function showForbiddenAlert(error) {
    const message = getForbiddenMessage(error);
    const currentAlert = store.getState().alert;

    if (currentAlert && currentAlert.type === 'alert-danger' && currentAlert.message === message) {
        return;
    }

    store.dispatch(alertActions.error(message));
}

apiClient.interceptors.request.use(
    config => {
        if (!config || !isInternalApiRequest(config.url)) {
            return config;
        }

        const token = getStoredToken();

        if (!token) {
            return config;
        }

        const headers = {
            ...(config.headers || {})
        };

        if (!headers['X-Id-Token'] && !headers['x-id-token']) {
            headers['X-Id-Token'] = token;
        }

        return {
            ...config,
            headers
        };
    },
    error => Promise.reject(error)
);

apiClient.interceptors.response.use(
    response => response,
    error => {
        const requestUrl = error && error.config ? error.config.url : null;
        const status = error && error.response ? error.response.status : null;

        if (isInternalApiRequest(requestUrl)) {
            if (logoutIfUnauthorized(error)) {
                store.dispatch({ type: userConstants.LOGOUT });
            } else if (status === 403) {
                showForbiddenAlert(error);
            }
        }

        return Promise.reject(error);
    }
);

apiClient.CancelToken = axios.CancelToken;
apiClient.all = axios.all;
apiClient.isCancel = axios.isCancel;
apiClient.spread = axios.spread;
apiClient.getConfig = getJsonAuthConfig;

export { getJsonAuthConfig };
export default apiClient;
